<template>
  <section class="distribution-calculator">
    <template v-if="screen==1">
      <section class="bg-grey px-3 quicklink coloured-panel ">
        <div class="container py-1">
          <div class="row h-100 align-items-center justify-content-center">
            <div class="col-12 col-md-11 text-center">
              <h3 class="mb-4" v-html="headingProp"></h3>
              <div class="mb-4" v-html="textProp"></div>
            </div>
          </div>
        </div>
      </section>

      <div class="container value-calculator question " >
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-11 text-center">
            <h3 class="mb-5 pb-1">Worker Productivity</h3>
            <div class="question_container">
              <p class="semibold larger">% Inventory accuracy</p>
            </div>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-9 text-center">
                <div class="sliderContainer mx-5 mx-md-3 mb-5">
                  <div class="min">0</div>
                  <div class="max">100%</div>
                  <vue-slider ref="inventoryAccuracy" v-model="inventoryAccuracy"  :tooltip-formatter="q0format"  :min="0" :max="100" :marks="[10,20,30,40,50,60,70,80,90]" />
                </div>
                <p class="semibold larger">Number of full-time pickers</p>
                <div class="number-input mb-5">
                  <input type="button" value="" @click="decrease('ftePickers')" class="button-minus">
                  <input v-model="ftePickers" name="ftePickers" type="number" >
                  <input type="button" value="" class="button-plus"  @click="increase('ftePickers')">
                </div>
                <div class="bg-grey px-3 py-4 pb-5 mb-4">
                  <p class="larger">Your company's cost of decreased worker productivity <br>due to inaccurate inventory</p>
                  <div class="row justify-content-center mb-4">
                    <div class="col-6 col-md-5">
                      <p class="input-label">Daily</p>
                      <input class="input" :value="formatPrice(prodDailyCost)" readonly />
                    </div>
                    <div class="col-6 col-md-5">
                      <p class="input-label">Annually</p>
                      <input class="input" :value="formatPrice(prodAnnualCost)" readonly />
                    </div>
                  </div>
                  <p class="mx-md-4 mb-2">How we got there: When inventory accuracy is low, workers spend more time searching for missplaced or missing items. Assuming an hourly rate of ${{ laborPerHour }} for each picker (the U.S. national average) results in the above daily and annual costs of that increased search time.</p>
                  <p class="mx-md-4 mb-0">Note: this does not include benefit costs, so your actual costs are likely higher </p>

                </div>
              </div>
            </div>
            <button @click="nextScreen" class="btn-grey btn btn-primary">Next</button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="screen==2">
      <div class="container value-calculator question " >
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-11 text-center">
            <h3 class="mb-5 pb-1">Picking Accuracy</h3>
            <div class="question_container">
              <p class="semibold larger">Average orders picked per day</p>
            </div>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-9 text-center">
                <div class="sliderContainer mx-5 mx-md-3 mb-5">
                  <div class="min">0</div>
                  <div class="max">600</div>
                  <vue-slider ref="pickedPerDay" v-model="pickedPerDay" :min="0" :max="600" :tooltip-formatter="q1format" :marks="[100,200,300,400,500]"  />
                </div>
                <div class="row">
                  <div class="col-12 col-md">
                    <p class="semibold larger">Incorrectly picked <br> orders per day</p>
                    <div class="number-input mb-2">
                      <input type="button" value="" @click="decrease('incorrectlyPicked')" class="button-minus">
                      <input v-model="incorrectlyPicked" name="incorrectlyPicked" type="number" min="0" >
                      <input type="button" value="" class="button-plus"  @click="increase('incorrectlyPicked')">
                    </div>
                    <p class="mb-5">This is calculated from inventory accuracy</p>
                  </div>
                  <div class="col-12 col-md">
                    <p class="semibold larger">Average time to fix incorrectly<br>  picked orders (hours)</p>
                    <div class="number-input mb-5">
                      <input type="button" value="" @click="decrease('timeToFixPicked')" class="button-minus">
                      <input v-model="timeToFixPicked" name="timeToFixPicked" type="number" min="0" >
                      <input type="button" value="" class="button-plus"  @click="increase('timeToFixPicked')">
                    </div>
                  </div>
                </div>

                <div class="bg-grey px-3 py-4 pb-5 mb-4">
                  <p class="larger">Cost to fix incorrectly picked orders</p>
                  <div class="row justify-content-center">
                    <div class="col-6 col-md-5">
                      <p class="input-label">Daily</p>
                      <input class="input" :value="formatPrice(pickDailyCost)" readonly />
                    </div>
                    <div class="col-6 col-md-5">
                      <p class="input-label">Annually</p>
                      <input class="input" :value="formatPrice(pickAnnualCost)" readonly />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                  <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                </div>
                <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                  <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="screen==3">
      <div class="container value-calculator question " >
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-11 text-center">
            <h3 class="mb-3 pb-1">Lost Sales</h3>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-9 text-center">
                <p class="mb-4">Historically, many companies did not see backorders and stockouts necessarily as losses. However as their expectations have shifted over time, customers are now more likely to go to a competitor who can fulfill their order on time and in full. How much is your company losing due to inaccurate inventory counts?</p>

                <div class="row justify-content-center">
                  <div class="col-12 col-md-auto">
                    <p class="semibold larger">Estimated weekly number of lost orders <br> due to backorders and stockouts </p>
                    <div class="number-input mb-5">
                      <input type="button" value="" @click="decrease('cancelledPerWeek')" class="button-minus">
                      <input v-model="cancelledPerWeek" name="cancelledPerWeek" type="number" min="0" >
                      <input type="button" value="" class="button-plus"  @click="increase('cancelledPerWeek')">
                    </div>
                  </div>
                </div>
                <div class="question_container">
                  <p class="semibold larger">Average $ per order</p>
                </div>
                <div class="sliderContainer mx-5 mx-md-3 mb-5 pb-3">
                  <div class="min">0</div>
                  <div class="max">6000</div>
                  <vue-slider ref="avgOrderValue" v-model="avgOrderValue" :min="0" :max="6000" :tooltip-formatter="q2format" :marks="[1000,2000,3000,4000,5000]"  />
                </div>

                <div class="bg-grey px-3 py-4 pb-5 mb-4">
                  <p class="larger">Opportunity cost of lost sales due to backorders and stockouts</p>
                  <div class="row justify-content-center">
                    <div class="col-6 col-md-5">
                      <p class="input-label">Daily</p>
                      <input class="input" :value="formatPrice(lostSalesDailyCost)" readonly />
                    </div>
                    <div class="col-6 col-md-5">
                      <p class="input-label">Annually</p>
                      <input class="input" :value="formatPrice(lostSalesAnnualCost)" readonly />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md align-content-end d-flex pl-md-5 order-md-0 ">
                  <button @click="prevScreen" class="prev btn-grey btn btn-primary"> Back</button>
                </div>
                <div class="col-6 col-md align-content-end d-flex justify-content-end  pr-md-5 order-md-2">
                  <button @click="nextScreen" class="next btn-grey btn btn-primary ">Next</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="screen==4">
      <div class="container value-calculator question " >
        <value-calculator-steps :screen="screen" @goToScreen="goToScreen"></value-calculator-steps>
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-11 text-center">
            <h3 class="mb-3 pb-1">Carrying Cost</h3>
            <div class="row justify-content-center">
              <div class="col-12 col-lg-9 text-center">
              <p class="mb-4">Inventory is one of the biggest expenses on a company's balance sheet, but often less appreciated is the opportunity cost of keeping extra inventory on hand "just in case." Without accurate ways to track inventory, many companies end up borrowing money and paying interest on stock they don't actually need, instead of using that money to invest in future development.</p>
                <div class="question_container">
                  <p class="semibold larger">% Cost to borrow money (APR)</p>
                </div>
                <div class="sliderContainer mx-5 mx-md-3 mb-5 pb-3">
                  <div class="min">0%</div>
                  <div class="max">10%</div>
                  <vue-slider ref="costToBorrow" v-model="costToBorrow" :min="0" :max="10" :tooltip-formatter="q3aformat" :marks="[1,2,3,4,5,6,7,8,9]"/>
                </div>

                <div class="question_container">
                  <p class="semibold larger">$ Inventory value</p>
                </div>
                <div class="sliderContainer mx-5 mx-md-3 mb-5 pb-3">
                  <div class="min">$500K</div>
                  <div class="max">$80M</div>
                  <vue-slider ref="costToBorrow" v-model="inventoryValue" :min="500000" :max="80000000" :interval="250000" :tooltip-formatter="q3bformat" :marks="{
                     10000000: '$10M',
                     20000000: '$20M',
                     30000000: '$30M',
                     40000000: '$40M',
                     50000000: '$50M',
                     60000000: '$60M',
                     70000000: '$70M',
                  }" />
                </div>

                <div class="bg-grey px-3 py-4 pb-5 mb-4">
                  <p class="larger">Cost of borrowing based on your company's inventory investment</p>
                  <div class="row justify-content-center">
                    <div class="col-6 col-md-5">
                      <p class="input-label">Daily</p>
                      <input class="input" :value="formatPrice(innventoryCostDailyCost)" readonly />
                    </div>
                    <div class="col-6 col-md-5">
                      <p class="input-label">Annually</p>
                      <input class="input" :value="formatPrice(innventoryCostAnnualCost)" readonly />
                    </div>
                  </div>
                </div>

                <button @click="nextScreen(); submit();" class="next btn btn-primary ">View Savings</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="screen==5"   class="value-calculator result  bg-turquoise" >
        <div class="container ">
          <div class="box bg-white dist-results">
            <div class="row  justify-content-center">
              <div class="col-11 text-left">
                <h4>Your Results</h4>
                <div class="row align-items-center mb-4 mt-4">
                  <div class="col">
                    <p>
                      With an inventory accuracy of <strong class="text-turquoise">{{ inventoryAccuracy }}%</strong>, we estimate your company could be spending up to <strong class="text-turquoise">{{ formatMillions(currentCost) }}</strong> extra per year due to decreased productivity, picking errors, lost sales, and unnecessary carrying costs.
                    </p>
                    <p>Best-in-class distribution companies typically run at <strong class="text-turquoise">99%</strong> inventory accuracy. By increasing inventory accuracy to <strong class="text-turquoise">99%</strong>, your company could save at least <strong class="text-turquoise">{{formatMillions(totalSaving)}}</strong> per year.</p>

                    <div class="bg-turquoise cta py-4 px-5 mt-4">
                      <h5 class="text-white font-weight-normal" style="line-height: 1.4;">Access your personalized report for a more in-depth analysis and to see how you could boost your inventory accuracy.</h5>
                      <button class="btn btn-primary btn-darkblue"  data-toggle="modal" data-target="#pdf-modal">Download the PDF</button>
                    </div>

                  </div>
                  <div class="col-6 col-md-4">
                    <svg class="img-fluid" xmlns="http://www.w3.org/2000/svg" width="380" height="420" viewBox="-20 -50 210 375">

                      <rect id="Rectangle_371" data-name="Rectangle 371" width="176" height="316" transform="translate(7.003)" fill="#E2E2E2"/>
                      <rect id="Rectangle_372" data-name="Rectangle 372" width="176" :height="totalSavingPercent * 3.16"
                            :transform="`translate(7.003 ${316 - (totalSavingPercent * 3.16)})`" fill="#253746"/>

                      <circle id="Ellipse_13-2" data-name="Ellipse 13" cx="10" cy="20" r="65" fill="#253746"/>

                      <text text-anchor="middle" id="_12_701" data-name="$12,701" transform="translate(11, 27)" fill="#fff" font-size="27" font-family="ProximaNova-Bold, Proxima Nova" font-weight="700"><tspan x="0" y="0">{{ formatMillions(totalSaving) }}</tspan></text>
                      <line id="Line_40" data-name="Line 40" x2="19.503" transform="translate(164 170.803)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_41" data-name="Line 41" x2="19.503" transform="translate(164 142.214)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_50" data-name="Line 50" x2="19.503" transform="translate(164 282.141)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_44" data-name="Line 44" x2="19.503" transform="translate(164 85.037)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_48" data-name="Line 48" x2="19.503" transform="translate(164 227.979)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_42" data-name="Line 42" x2="19.503" transform="translate(164 113.625)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_49" data-name="Line 49" x2="19.503" transform="translate(164 255.538)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_43" data-name="Line 43" x2="19.503" transform="translate(164 59.463)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_47" data-name="Line 47" x2="19.503" transform="translate(164 199.391)" fill="none" stroke="#fff" stroke-width="5"/>
                      <line id="Line_45" data-name="Line 45" x2="19.503" transform="translate(164 27.859)" fill="none" stroke="#fff" stroke-width="5"/>
                    </svg>
                  </div>
                </div>
                <input type="hidden" :value="submissionId" id="submissionId">
              </div>
            </div>
            <div class="row  justify-content-center">
              <div class="col-11 text-left">
                <div class="border py-4 px-5">
                  <h5 class=" font-weight-normal" style="line-height: 1.4;">We made assumptions in building this calculator. If you’d like to get a tailored version of this calculation for your company, we can do so on a <strong>10-minute call.</strong></h5>
                  <a class="btn btn-primary btn-turquoise" href="https://resources.cloudinventory.com/contact-us" target="_blank">Schedule a Call</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

  </section>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
  components: {
    VueSlider,
  },
  props:[
    'headingProp','textProp'
  ],
  data() {

    return {
      laborPerHour: 15.51,

      ftePickers:5,
      inventoryAccuracy:90,

      pickedPerDay: 100,
      incorrectlyPicked: 10,
      timeToFixPicked: 0.25,

      avgOrderValue: 1000,
      cancelledPerWeek: 5,

      costToBorrow: 5,
      inventoryValue: 20000000,

      submissionId: 0,
      mousedown: '',
      screen:1,

      q0format: '{value}%',
      q1format: '{value} ',
      q2format: '${value}',
      q3aformat: '{value}%',
      q3bformat: function (value){
        if(value < 1000000){
          let val = (value/1000);
          return '$'+val.toString()+'K'
        }else {
          let val = (value / 1000000);
          return '$' + val.toString() + 'M'
        }
      },
      q4format: '{value} reports',
      q5format: '{value}%',
    }
  },
  watch:{
    inventoryAccuracy(newVal, oldVal) {
      this.incorrectlyPicked = ((1-(newVal/100)) * this.pickedPerDay).toFixed()
    },
    pickedPerDay(newVal, oldVal) {
      this.incorrectlyPicked = ((1-(this.inventoryAccuracy/100)) * newVal).toFixed()
    }
  },
  computed:{
    pickWaste: function (){
      return 8 * (1-(this.inventoryAccuracy/100)) * this.ftePickers
    },
    prodDailyCost: function (){
      return (this.pickWaste * this.laborPerHour)
    },
    prodAnnualCost: function (){
      return (this.prodDailyCost * 220)
    },
    pickDailyCost: function (){
      return (this.timeToFixPicked * this.incorrectlyPicked * this.laborPerHour)
    },
    pickAnnualCost: function (){
      return (this.pickDailyCost * 220)
    },
    lostSalesDailyCost: function (){
      return ((this.avgOrderValue * this.cancelledPerWeek) / 5)
    },
    lostSalesAnnualCost: function (){
      return (this.lostSalesDailyCost * 220)
    },
    innventoryCostDailyCost: function (){
      return (this.innventoryCostAnnualCost / 365)
    },
    innventoryCostAnnualCost: function (){
      return (this.inventoryValue * (this.costToBorrow/100))
    },
    //savings
    prodNewDaily:function (){
      return 8 * 0.01 * this.ftePickers * this.laborPerHour ;
    },
    prodNewAnnual:function (){
      return this.prodNewDaily * 220;
    },
    prodSavings:function (){
      var orgVal = this.prodAnnualCost;
      var newVal = this.prodNewAnnual;
      if(newVal < orgVal){
        return orgVal - newVal;
      } else{
        return 0;
      }
    },
    pickNewDaily:function (){
      return ((this.pickedPerDay * 1.05) * 0.01) * this.timeToFixPicked * this.laborPerHour ;
    },
    pickNewAnnual:function (){
      return this.pickNewDaily * 220;
    },
    pickSavings:function (){
      var orgVal = this.pickAnnualCost;
      var newVal = this.pickNewAnnual;
      if(newVal < orgVal){
        return orgVal - newVal;
      } else{
        return 0;
      }
    },
    lostNewDaily:function (){
      return ((this.cancelledPerWeek / 2) * this.avgOrderValue / 5);
    },
    lostNewAnnual:function (){
      return this.lostNewDaily * 220;
    },
    lostSalesSavings:function (){
      var orgVal = this.lostSalesAnnualCost;
      var newVal = this.lostNewAnnual;
      if(newVal < orgVal){
        return orgVal - newVal;
      } else{
        return 0;
      }
    },
    inventNewDaily:function (){
      return this.inventNewAnnual / 365;
    },
    inventNewAnnual:function (){
      return (this.inventoryValue * 0.6) * (this.costToBorrow / 100);
    },
    inventoryCostSavings:function (){
      var orgVal = this.innventoryCostAnnualCost;
      var newVal = this.inventNewAnnual;
      if(newVal < orgVal){
        return orgVal - newVal;
      } else{
        return 0;
      }
    },
    totalSaving: function (){
      return this.inventoryCostSavings+this.lostSalesSavings+this.pickSavings+this.prodSavings;
    },
    currentCost: function (){
      return this.innventoryCostAnnualCost+this.lostSalesAnnualCost+this.pickAnnualCost+this.prodAnnualCost;
    },
    totalSavingPercent: function (){
      return 100 - ((this.totalSaving / this.currentCost) * 100);
    }
  },
  methods: {
    submit() {
      var self = this;
      axios.post('/actions/distcalc/distcalc/save', {
        data: {
          ftePickers:self.ftePickers,
          inventoryAccuracy:self.inventoryAccuracy,

          pickedPerDay: self.pickedPerDay,
          incorrectlyPicked: self.incorrectlyPicked,
          timeToFixPicked: self.timeToFixPicked,

          avgOrderValue: self.formatPrice(self.avgOrderValue),
          cancelledPerWeek: self.cancelledPerWeek,

          costToBorrow: self.costToBorrow,
          inventoryValue: self.formatMillions(self.inventoryValue),

          //results

          productivityCost: self.formatPrice(self.prodAnnualCost),
          productivitySavings: self.formatPrice(self.prodSavings),

          pickingCost: self.formatPrice(self.pickAnnualCost),
          pickingSavings: self.formatPrice(self.pickSavings),

          lostSalesCost: self.formatPrice(self.lostSalesAnnualCost),
          lostSalesSavings: self.formatPrice(self.lostSalesSavings),

          innventoryCost: self.formatMillions(self.innventoryCostAnnualCost),
          innventorySavings: self.formatMillions(self.inventoryCostSavings),

          currentCost : self.formatMillions(self.currentCost),
          totalSavings : self.formatMillions(self.totalSaving),
        },
      })
      .then(function (response) {
        self.submissionId = response.data.id;
        $('input[name="cost_calculator_report_pdf"]').val("https://nextw.com/actions/distcalc/distcalc/pdf?id="+self.submissionId);
        console.log(response.data.id);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    formatMillions(value) {
      if(value < 1000000){
        let val = (value/1000);
        return '$'+val.toFixed(0)+'K'
      }else {
        let val = (value / 1000000);
        return '$' + val.toFixed(1) + 'M'
      }
    },
    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return '$'+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    nextScreen(){
      this.screen ++;
      var nav = $('header').height();
      var offset = $('#app').offset();
      var position = offset.top - nav ;
      if(this.screen  < 6){
        position = position + 30;
      }
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();

      $('html,body').animate({'scrollTop': position},300)
    },
    prevScreen(){
      this.screen --;
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();
    },
    goToScreen(screen){
      this.screen = screen;
      if(screen == 5){
        this.submit();
      }
      $('[data-toggle="tooltip"]').tooltip('dispose');
      this.$forceUpdate();
    },
    sliderDown(ref,direction){
      var self = this;
      this.adjustSlider(ref,direction);
      this.mousedown = setInterval(function (){
        self.adjustSlider(ref,direction);
      },500);
    },
    sliderUp(){
      clearInterval(this.mousedown);
    },
    increase(ref){
      this[ref] ++;
    },
    decrease(ref){
      this[ref] -- ;
    },
    adjustSlider(ref,direction){
      var current = this.$refs[ref].getIndex();
      if(direction == 'increase'){
        current++;
      }else{
        current--;
      }
      this.$refs[ref].setIndex(current);
    }
  }
}
</script>